import { render } from "./403.vue?vue&type=template&id=59f55ee7"
const script = {}

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__